import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {Tag} from 'primeng/tag';
import {AppNumberPipe} from '@frontend/shared';

@Component({
  selector: 'app-reference-score-badge',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AppNumberPipe, Tag],
  templateUrl: './reference-score-badge.component.html',
})
export class ReferenceScoreBadgeComponent {
  readonly scores = input.required<ReadonlyMap<number, number>>();
  readonly scaNumber = input.required<number>();

  protected readonly hasScore = computed<boolean>(() => this.scores().has(this.scaNumber()));

  protected readonly score = computed<number>(() => {
    const current: number | undefined = this.scores().get(this.scaNumber());

    if (current === undefined) {
      throw new Error(`No project reference score for SCA ${this.scaNumber()}`);
    }

    return current;
  });
}
